<!--
 * @Author: 汪俊洪
 * @Date: 2021-07-15 15:30:48
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-08-20 17:27:48
 * @Description: 上传文件
-->
<template>
  <el-upload
    class="upload-demo"
    :action="action"
    :limit="limit"
    :on-exceed="handleExceed"
    :before-upload="beforeUploadEvent"
    :on-success="onSuccess"
    :on-remove="handleRemove"
    :on-error="onError"
    :on-preview="onPreview"
    :file-list="list"
    :accept="accept"
    :headers="headers"
    :disabled="disableRemove"
    :data="fileSuffixType"
  >
    <el-button size="small" type="primary">{{ buttonText }}</el-button>
    <div v-if="tip" slot="tip" class="el-upload__tip">
      {{ tip }}
    </div>
  </el-upload>
</template>

<script>
import { getAccessToken } from '@/utils/userInfo'
export default {
  props: {
    limit: {
      // 能传几条数据
      type: Number,
      default: 1
    },
    fileList: {
      // 默认显示的数据
      type: Array,
      default: function () {
        return []
      }
    },
    // 提示文字
    tip: {
      type: String,
      default: ''
    },
    // 限制上传类型
    accept: {
      type: String,
      default: ''
    },
    // 文件上传限制提示文案
    handleExceedText: {
      type: String,
      default: ''
    },
    // 上传前的校验
    beforeUpload: {
      type: Function,
      default: null
    },
    // 按钮文案
    buttonText: {
      type: String,
      default: '点击上传'
    },
    action: {
      type: String,
      default:
        window.SITE_CONFIG['apiURL'] + '/front/fileupload/alioss/v2/upload'
    },
    // 按钮文案
    fileSuffixType: {
      type: Object,
      default: () => ({
        fileSuffixType: 'allType'
      })
    },
    disableRemove: { type: Boolean, default: false }
  },
  data () {
    return {
      list: [],
      headers: {
        Authorization: 'Bearer ' + getAccessToken() || ''
      }
    }
  },
  watch: {
    fileList: {
      handler () {
        this.list = this.fileList
      },
      immediate: true
    }
  },
  methods: {
    // 文件超过限制提示
    handleExceed (files, fileList) {
      this.$message.warning(
        this.handleExceedText ||
          `当前限制选择 ${this.limit} 个文件，本次选择了 ${
            files.length
          } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      )
    },
    // 上传前校验
    beforeUploadEvent (file) {
      if (!this.beforeUpload) {
        return this.defaultBeforeUpload(file)
      }
      return this.beforeUpload(file)
    },
    defaultBeforeUpload (file) {
      console.log('defaultBeforeUpload')
      const isLt2M = file.size / 1024 / 1024 < 100
      if (!isLt2M) {
        this.$message.error('上传的附件不得大于100MB')
        return false
      }
      return true
    },
    setData (fileList) {
      let arr = fileList.map((item) => {
        // 需要判断是回显的还是新上传的
        if (
          item.response &&
          item.response.data &&
          item.response.data.aliOssId
        ) {
          return item.response.data.aliOssId
        }
        // 返回回显的
        return item.aliOssId
      })
      return arr
    },
    // 成功的回调
    onSuccess (res, file, fileList) {
      console.log(res, file, fileList)
      if (res.code === 0) {
        // 参数返回给父组件
        this.$emit('onSuccess', this.setData(fileList))
        this.$emit('afterSuccess', res.data)
      } else {
        fileList.pop()
        this.$message.error(res.message || '上传失败，请重试')
      }
      this.list = fileList
    },
    // 删除的回调
    handleRemove (file, fileList) {
      this.$emit('onSuccess', this.setData(fileList))
      this.list = fileList
    },
    // 失败的回调
    onError (res) {
      this.$message.error(res.message || '上传失败，请重试')
    },
    onPreview ({ response: { data: file } }) {
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = file.url || file.fileUrl
      link.target = '_blank'
      link.download = file.fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style lang="scss" scoped></style>
